import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledBasePagination = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-13psekq-0"
})(["display:flex;width:fit-content;flex-wrap:wrap;gap:", ";", ""], ({
  theme
}) => theme.spacing.small.default, isMobile(css(["flex-direction:column;width:auto;align-items:center;gap:", ";"], ({
  theme
}) => theme.spacing.small.mobile)));
const PaginationNavGroup = /*#__PURE__*/styled('nav').withConfig({
  componentId: "sc-storm-ui-40025937__sc-13psekq-1"
})(["display:flex;flex-direction:row;flex-wrap:nowrap;gap:", ";", ""], ({
  theme
}) => theme.spacing.xxxsmall.default, isMobile(css(["gap:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.mobile)));

export { PaginationNavGroup as P, StyledBasePagination as S };
//# sourceMappingURL=Pagination.styles-CJ0RfuXg.js.map
